import { createFileRoute, redirect } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';

export const Route = createFileRoute('/settings/')({
  validateSearch: (search) => settingsSearchSchema.parse(search),
  beforeLoad: ({ search }) => {
    return redirect({
      to: '/settings/preferences',
      search: settingsSearchSchema.parse(search),
    });
  },
});
